<template>
  <div>
    <div v-if="isProductReq">
      <el-radio-group
        v-model="newFilterType"
        :disabled="isDisabled"
        @change="filterTypeChange"
      >
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">指定商品</el-radio>
        <el-radio :label="2" v-if="isShowExclude">排除商品</el-radio>
      </el-radio-group>
      <jd-button
        @click="exposureProducts(venderId)"
        :disabled="newFilterType == 0 || (btnDisabled ? true : isDisabled)"
        class="ml8"
        v-loading="isLoading"
        v-if="newFilterType != 0 && newVenderIds.length == 1"
      >
        <span>{{ addGoodText }}{{ newSellerSkuList[0].skuIds.length }}</span>
        <span v-if="limitNum">/{{ limitNum }}</span> <span v-else>个</span>
      </jd-button>
      <div v-else-if="newFilterType != 0 && newVenderIds.length > 1">
        <div v-for="item in newSellerSkuList" :key="item.venderId">
          <div class="flexc-cen-x mb8">
            <div class="shop-label">{{ getTitle(item.venderId) }}</div>
            <jd-button
              @click="exposureProducts(item.venderId)"
              :disabled="newFilterType == 0 || (btnDisabled ? true : isDisabled)"
              v-loading="isLoading"
            >
              <span>{{ addGoodText }}{{ item.skuIds.length }}</span>
              <span v-if="limitNum">/{{ limitNum }}</span>
              <span v-else>个</span>
            </jd-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="newVenderIds.length == 1">
        <jd-button
          @click="exposureProducts(newSellerSkuList[0].venderId)"
          :disabled="isDisabled"
          class="ml8"
          v-loading="isLoading"
          >{{ addGoodText }}（{{ newSellerSkuList[0].skuIds.length }}/{{
            limitNum
          }}）</jd-button
        >
        <div v-if="newSellerSkuList.length > 0">
          <slot name="goodsScope" :scopeItem="newSellerSkuList[0]"></slot>
        </div>
      </div>
      <div v-else-if="newVenderIds.length > 1">
        <div v-for="item in newSellerSkuList" :key="item.venderId">
          <div class="flexc-cen-x mb8">
            <div class="shop-label">{{ getTitle(item.venderId) }}</div>
            <jd-button
              @click="exposureProducts(item.venderId)"
              :disabled="isDisabled"
              v-loading="isLoading"
            >
              {{ addGoodText }}（{{ item.skuIds.length }}/{{ limitNum }}）
            </jd-button>
          </div>
          <div class="mb16">
            <slot name="goodsScope" :scopeItem="item"></slot>
          </div>
        </div>
      </div>
    </div>
    <!-- 指定/排除购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="limitNum ? true : false"
      :limitNum="limitNum"
      :disabled="backgroundOpacity"
      :venderId="curretnVenderId"
      isInteract
    ></selectGoodsMonitor>
  </div>
</template>
<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { mapState } from "vuex";
export default {
  components: {
    selectGoodsMonitor,
  },
  props: {
    filterType: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
    skuIdList: {
      type: Array,
      default: () => [],
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    sellerSkuList: {
      type: Array,
      default: () => [],
    },
    venderIds: {
      type: Array,
      default: () => [],
    },
    multiShopGoods: {
      type: Array,
      default: () => [],
    },
    isShowExclude: {
      type: Boolean,
      default: true,
    },
    addGoodText: {
      type: String,
      default: "已选择",
    },
    limitNum: {
      type: Number,
      default: 5000,
    },
    // 是否是已创建活动
    isCreated: {
      type: Boolean,
      default: false,
    },
    // 是否是商品需求
    isProductReq: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      specifiedGoods: [],
      selectGoodsState: false,
      selectGoodsArr: [],
      curretnVenderId: "",
    };
  },
  computed: {
    ...mapState(["shopList"]),
    newFilterType: {
      get() {
        return this.filterType;
      },
      set(val) {
        this.$emit("update:filterType", val);
      },
    },
    newSkuIdList: {
      get() {
        return this.skuIdList;
      },
      set(val) {
        this.$emit("update:skuIdList", val);
      },
    },
    newSellerSkuList: {
      get() {
        return this.sellerSkuList;
      },
      // set(val) {
      //   this.$emit("update:sellerSkuList", val);
      // },
    },
    newVenderIds: {
      get() {
        return this.venderIds;
      },
      set(val) {
        this.$emit("update:venderIds", val);
      },
    },
    newMultiShopGoods: {
      get() {
        return this.multiShopGoods;
      },
      set(val) {
        this.$emit("update:multiShopGoods", val);
      },
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    getTitle() {
      return (venderId) => {
        const item = this.shopList.find((v) => v.venderId == venderId);
        if (item) {
          return item.shopTitle;
        } else {
          return "";
        }
      };
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    async exposureProducts(venderId) {
      if (!this.isProductReq && this.limitNum) {
        const obj = this.newSellerSkuList.some((item) => {
          return item.skuIds.length >= this.limitNum;
        });
        if (obj) {
          this.$message({
            message: `商品数量不能超过限制数量${this.limitNum}个`,
            type: "warning",
          });
          return;
        }
      }
      this.selectGoodsArr = [];
      if (this.newFilterType >= 1 || !this.isProductReq) {
        this.curretnVenderId = venderId;
      }
      if (this.isCreated && this.newSellerSkuList.length > 0) {
        const skuIdList = this.newSellerSkuList.filter(
          (item) => item.venderId == venderId
        );
        if (skuIdList.length > 0 && skuIdList[0].skuIds.length > 0) {
          const skuIds = skuIdList[0].skuIds;
          try {
            this.isLoading = true;
            const res = await getTaobaoItemListSku({
              current: 1,
              size: skuIds.length,
              skuIds: skuIds,
              venderId: venderId,
            });
            if (res.code == 1) {
              this.selectGoodsArr = res.data.records || [];
            }
            this.isLoading = false;
          } catch (error) {
            this.isLoading = false;
          }
        }
        this.selectGoodsState = true;
      } else {
        if (this.newSellerSkuList.length > 0) {
          this.selectGoodsArr = this.newSellerSkuList.filter(
            (item) => item.venderId == venderId
          )[0].itemList;
        }
        this.selectGoodsState = true;
      }
    },
    filterTypeChange(val) {
      this.selectGoodsArr = [];
      this.newSellerSkuList.forEach((item) => {
        item.skuIds = [];
        item.itemList = [];
      });
      this.$emit("changeFilterType", val);
    },
    selectGoodsClose(data) {
      if (data) {
        let selectGoods = [];
        const skuIds = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoods.push(fomeVaule);
          skuIds.push(data[index].skuId);
        });
        this.selectGoodsArr = selectGoods;
        this.newMultiShopGoods.forEach((item) => {
          if (item.venderId == this.curretnVenderId) {
            item.skuIds = skuIds;
          }
        });
        this.newSellerSkuList.forEach((item) => {
          if (item.venderId == this.curretnVenderId) {
            item.skuIds = skuIds;
            item.itemList = selectGoods;
          }
        });
      }
      this.selectGoodsState = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-label {
  margin-right: 12px;
  min-width: 60px;
  text-align: right;
  font-size: 12px !important;
}
.mb8 {
  margin-bottom: 8px;
}
</style>
